/** Primeras jornadas: filtro por stage_id. El resto se agrupa en un solo tab. */
export const EARLY_MATCH_STAGES = ['Grupos', 'Dieciseisavos', 'Octavos']

// Obtiene los stage ids que se deben pedir para la vista actual.
export const getPointsGroupPickStageIds = (currentStage, bracketStages) => {
  if (!currentStage) return []
  if (EARLY_MATCH_STAGES.includes(currentStage.name)) {
    return [currentStage.id]
  }
  if (!bracketStages?.length) {
    return [currentStage.id]
  }
  return bracketStages
    .filter((stage) => !EARLY_MATCH_STAGES.includes(stage.name))
    .map((stage) => stage.id)
}

// Une respuestas de picks de varias etapas en una sola lista por entrada.
export const mergeBracketPointsGroupPicks = (datasets) => {
  if (!datasets?.length) {
    return { items: [], page: 1, pages: 0 }
  }
  if (datasets.length === 1) {
    return datasets[0]
  }

  const merged = { ...datasets[0] }
  const byEntryId = {}

  datasets.forEach((data) => {
    (data.items || []).forEach((item) => {
      const key = item.bracket_entry_id
      if (!byEntryId[key]) {
        byEntryId[key] = {
          ...item,
          bracket_picks: { ...(item.bracket_picks || {}) },
        }
        return
      }

      byEntryId[key] = {
        ...byEntryId[key],
        ...item,
        bracket_picks: {
          ...(byEntryId[key].bracket_picks || {}),
          ...(item.bracket_picks || {}),
        },
      }
    })
  })

  merged.items = Object.values(byEntryId)
  merged.pages = Math.max(...datasets.map((data) => data.pages || 1))
  return merged
}

// Pide los picks necesarios para la vista, incluyendo tabs que agrupan varias etapas.
export const fetchBracketPointsGroupPicksForStageView = async (
  API,
  bracketId,
  currentStage,
  bracketStages,
  page,
  limit
) => {
  const stageIds = getPointsGroupPickStageIds(currentStage, bracketStages)

  if (stageIds.length <= 1) {
    const response = await API.fetchBracketPointsGroupPicks(
      bracketId,
      stageIds[0] || currentStage.id,
      page,
      limit
    )
    return response.data
  }

  const responses = await Promise.all(
    stageIds.map((stageId) => API.fetchBracketPointsGroupPicks(bracketId, stageId, page, limit))
  )

  return mergeBracketPointsGroupPicks(responses.map((response) => response.data))
}

// Construye un mapa de equipos usando los equipos base y los equipos de los partidos.
export const buildBracketTeamsIndex = (bracketTeams, matches) => {
  const teams = { ...(bracketTeams || {}) }

  ;(matches || []).forEach((match) => {
    if (match.home_team_id != null && match.home_team) {
      teams[match.home_team_id] = match.home_team
    }
    if (match.away_team_id != null && match.away_team) {
      teams[match.away_team_id] = match.away_team
    }
  })

  return teams
}

// Resuelve el equipo seleccionado por un pick usando el mapa y los partidos disponibles.
export const resolvePickTeam = (pickId, teams, match, allMatches) => {
  if (pickId === null || pickId === undefined) return null

  const normalizedPickId = Number(pickId)

  if (teams && (teams[pickId] || teams[String(pickId)])) {
    return teams[pickId] || teams[String(pickId)]
  }

  if (Number(match.home_team_id) === normalizedPickId && match.home_team) {
    return match.home_team
  }
  if (Number(match.away_team_id) === normalizedPickId && match.away_team) {
    return match.away_team
  }

  if (allMatches?.length) {
    for (let i = 0; i < allMatches.length; i += 1) {
      const bracketMatch = allMatches[i]
      if (Number(bracketMatch.home_team_id) === normalizedPickId && bracketMatch.home_team) {
        return bracketMatch.home_team
      }
      if (Number(bracketMatch.away_team_id) === normalizedPickId && bracketMatch.away_team) {
        return bracketMatch.away_team
      }
    }
  }

  return null
}

// Define si un pick debe pintarse como ganador, perdedor o sin calificación.
export const getPickResultClass = (pickId, match) => {
  if (match.enabled == false) {
    if (match.status === 'upcoming') return ''
    return (pickId !== null && pickId === match.winning_pick) ? 'winner' : 'looser'
  }
  if (match.sort_status === 1) return ''
  if (match.status !== 'upcoming') {
    return (pickId !== null && pickId === match.winning_pick) ? 'winner' : 'looser'
  }
  return 'looser'
}
